<template>
  <div class="my-profile-page">
    <h4 class="tw-text-[#6d7287] tw-text-base tw-mb-5">{{ t('common.nav.my_profile') }}</h4>

    <div class="my-profile-content tw-w-full tw-px-4">
      <div class="tw-flex tw-flex-wrap tw-gap-4">
        <div
          :class="{
            'lg:tw-w-[calc(41.67%-0.5rem)]': currentUser?.show_signature,
            'tw-w-full': !currentUser?.show_signature,
          }"
        >
          <MainInfo />
        </div>
        <div class="lg:tw-w-[calc(58.33%-0.5rem)]" v-if="currentUser?.show_signature">
          <UserSignature />
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap tw-gap-4 tw-mt-4" v-if="currentUser?.show_signature">
        <div class="tw-w-full">
          <CustomerSignatures />
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap tw-gap-4 tw-mt-4">
        <div class="lg:tw-w-[calc(41.67%-0.5rem)]">
          <ResetPassword />
        </div>
        <div class="lg:tw-w-[calc(58.33%-0.5rem)]">
          <SetVacationMode />
        </div>
      </div>
      <div class="tw-flex tw-flex-wrap tw-gap-4 tw-mt-4">
        <div class="lg:tw-w-[calc(41.67%-0.5rem)]">
          <NotificationPreference />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ResetPassword } from '@/components/my-profile';
import { MainInfo } from '@/components/my-profile';
import { UserSignature } from '@/components/my-profile/';
import { CustomerSignatures } from '@/components/my-profile/';
import { SetVacationMode } from '@/components/my-profile/';
import { useUserStore } from '@/stores/user.store';
import NotificationPreference from '@/components/my-profile/NotificationPreference.vue';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';

const { t } = useI18n();
const { currentUser } = useUserStore();
const { setBreadcrumbs } = useBreadcrumbs();

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'common.nav.my_profile',
    },
  ]);
});
</script>

<style scoped></style>
